import Splide from '@splidejs/splide'

export function slider() {
	const renderControls = (slider) => {
		if (!slider) {
			return
		}

		const arrows = slider.querySelector('*:not(.splide__controls) > .splide__arrows')
		const pagination = slider.querySelector('*:not(.splide__controls) > .splide__pagination')
		const overlayExists = !!slider.querySelector('.splide__controls')

		if (arrows || pagination) {
			let overlay = slider.querySelector('.splide__controls')

			if (!overlay) {
				overlay = document.createElement('div')
				overlay.classList.add('splide__controls')
			}

			if (pagination) {
				if (overlay.querySelector('.splide__pagination__page')) {
					overlay.querySelector('.splide__pagination__page').remove()
				}

				if (overlay.children.length > 0) {
					overlay.insertBefore(pagination, overlay.children[1])
				} else {
					overlay.appendChild(pagination)
				}
			}

			if (arrows) {
				if (overlay.querySelector('.splide__arrow--prev')) {
					overlay.querySelector('.splide__arrow--prev').remove()
				}
				if (overlay.querySelector('.splide__arrow--next')) {
					overlay.querySelector('.splide__arrow--next').remove()
				}

				const prev = arrows.querySelector('.splide__arrow--prev')
				const next = arrows.querySelector('.splide__arrow--next')

				if (prev) {
					overlay.prepend(prev)
				}

				if (next) {
					overlay.appendChild(next)
				}

				arrows.remove()
			}

			if (!overlayExists) {
				slider.appendChild(overlay)
			}
		}
	}

	const resetSlider = (slider) => {
		const sliderList = slider.querySelector('.splide__list')
		const slides = slider.querySelectorAll('.splide__slide')

		if (slider) {
			slider.removeAttribute('aria-label')
			if (slider.getAttribute('title')) {
				slider.setAttribute('aria-label', slider.getAttribute('title'))
			}

			if (sliderList) {
				sliderList.removeAttribute('role') // Remove the invalid role
				sliderList.setAttribute('role', 'list') // Add a valid role
			}

			if (slides) {
				slides.forEach((slide) => {
					slide.removeAttribute('role')
					slide.setAttribute('role', 'listItem')
				})
			}

			renderControls(slider)
		}
	}

	const sliders = []
	let elms = document.querySelectorAll('.splide:not(.splide--facts)')

	for (let i = 0; i < elms.length; i++) {
		const slider = new Splide(elms[i])

		slider.on('ready', function () {
			resetSlider(slider.root)
		})

		// Add resize event with debounce for performance
		let resizeTimer
		window.addEventListener('resize', function () {
			clearTimeout(resizeTimer)
			resizeTimer = setTimeout(function () {
				renderControls(slider.root)
			}, 250) // 250ms debounce delay
		})

		sliders.push(slider.mount())
	}

	return sliders
}
